import React, { Component } from "react";
import { styled } from "../../../stitches.config";
import KulkiSvg from "../../common/KulkiSvg";

import Editor from './EditorOnnetwork'
import EditorWrapper from '../../EditorWrapper'
import OnnetworkPlayer from '../../OnnetworkPlayer'


class AOnNetworkPlayer extends Component {

  receiveMediaInfo(e) {
    try {
      const com = JSON.parse(e.data);
      const target = document.getElementById("onnetwork-video-title");

      if (com.title && target) {
        target.innerHTML = com.title;
      }
    } catch (e) { }
  }

  /**
   * nigdy nie aktualizuj, wyświetlaj te same reklamy
   */
  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  componentDidMount() {
    window.addEventListener('message', this.receiveMediaInfo);
  }

  render() {
    const { props } = this;
    const settings = props.settings;

    return (
      <div className={props.classes + ' pos-relative'} {...props.events} >
        <EditorWrapper {...props} editor={Editor} draggable={false} />

        <BoxWrapper>
          <Content>
            <OnnetworkPlayer mid={settings.playlist_id} />
            <Title>
              <KulkiSvg />
              <span id="onnetwork-video-title"></span>
            </Title>
          </Content>
        </BoxWrapper>
      </div>
    );
  }
}

const BoxWrapper = styled("div",{
  padding: "12px 0",
  position: "relative"
});

const Content = styled("div",{
  border: "1px solid rgba(151,151,151,0.15)",
  borderWidth: "0 0 1px 1px",
  borderRadius: "0 0 0 6px",
  backgroundColor: "#fff"
});

const PlayerContainer = styled("div",{
  margin: 0,
});

const Title = styled("div",{
  color: "#272424",
  fontSize: "14px",
  padding: "5px",
  paddingLeft: "25px",
  display: "block",
  position: "relative",
  height: "86px",
  overflow: "hidden",
  "svg":{
    display: "block",
    position: "absolute",
    top: 0,
    left: "9px"
  }
});

export default AOnNetworkPlayer;
